/** The fields needed to work out how much iron a lift actually moved. */
export interface LoadInput {
  enteredWeightLb: number;
  reps: number;
  inputWeightMultiplier?: number;
  /** Fraction of body weight in the load; > 0 means a bodyweight lift. */
  bodyWeightFactor?: number;
}

/**
 * The external weight moved in one rep, in pounds.
 *
 * This is deliberately NOT a measure of effort - it is the number on the bar.
 * The points score already handles effort, and handles it better; this exists
 * only for the "heaviest lift" and "volume" awards, which are about iron.
 *
 * Two rules:
 *
 * - A dumbbell lift enters the weight of one dumbbell, so it doubles (whatever
 *   `inputWeightMultiplier` says), because that is what was really lifted.
 * - Pull-ups and chin-ups score **zero**. Their load is body weight, which is
 *   not a weight anyone chose to lift, and counting it would let a set of
 *   chin-ups out-volume a heavy squat session on arithmetic alone.
 */
export function loadMovedLb(lift: LoadInput): number {
  if ((lift.bodyWeightFactor ?? 0) > 0) return 0;
  return lift.enteredWeightLb * (lift.inputWeightMultiplier ?? 1);
}

/** Total weight moved by one lift: the load, times the reps. */
export function volumeLb(lift: LoadInput): number {
  return loadMovedLb(lift) * lift.reps;
}
